export interface NewContractAddendum {
    contractAddendumName: string;
    contractAddendumDescription: string;
    contractId: number;
    contractAddendumExpiryStartDate?: Date;
    contractAddendumExpiryEndDate?: Date;
    contractAddendumType: ContractAddendumType;
}

export enum ContractAddendumType {
    ContractAddendum = 0,
    NegociationInstance = 1,
}